const mapConfig = {
  formSelector: {
    subscribe: '.blue-form form[id^="form-EmailSubscription-"]',
    business: '.blue-form form[id^="form-FormGetAdvice_Business-"]',
    personal: '.blue-form form[id^="form-FormGetAdvice-"]',
  },
  context: {
    dev: {
      endpoint: 'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DAs00000GFgwO',
      oid: '00DAq000007ETnh',
    },
    prod: {
      endpoint: 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D8c0000015nTa',
      oid: '00D8c0000015nTa',
    },
  },
  formInputs: {
    subscribe: {
      first_name: 'input[name*=".TextInput.Value"]',
      last_name: 'input[name*=".TextInput_1.Value"]',
      email: 'input[name*=".Email.Email"]',
      signup: ['input[type="checkbox"][name*=".SubscriptionList.HtmlOptions"]'],
    },
    personal: {
      first_name: 'input[name*=".YourName.Value"]',
      last_name: 'input[name*=".TextInput.Value"]',
      email: 'input[name*=".EmailAddress.Email"]',
      phone: 'input[name*=".PhoneNumber.PhoneNumber"]',
      branch: 'select[name*=".PreferredBranch.SelectedValue"]',
      comment: 'textarea[name*=".CommentQuestion.Value"]',
      expressed_interest: 'input#ExpressedInterest',
      product_line: 'input#ProductLine',
      product_enquiry: 'input#ProductEnquiryWebsite',
    },
    business: {
      business_name: 'input[name*=".BusinessName.Value"]',
      first_name: 'input[name*=".YourName.Value"]',
      last_name: 'input[name*=".TextInput.Value"]',
      email: 'input[name*=".EmailAddress.Email"]',
      phone: 'input[name*=".PhoneNumber.PhoneNumber"]',
      branch: 'select[name*=".PreferredBranch.SelectedValue"]',
      comment: 'textarea[name*=".CommentQuestion.Value"]',
      expressed_interest: 'input#ExpressedInterest',
      product_line: 'input#ProductLine',
      product_enquiry: 'input#ProductEnquiryWebsite',
    },
  },
  salesforceIDs: {
    shared: {
      expressed_interest: '00N8c00000Fib91',
      product_line: '00N8c00000fxzpW',
      product_enquiry: '00NN3000000a6zm',
      branch: '00N8c00000fxzpS',
      comment: '00N8c00000hNM9d',
      referrer: '00N8c00000g6xo0',
      contact: '00N8c00000fxzpT',
    },
    dev: {
      subscribe: {
        enews: '00N8c00000fy1UO',
        marketinsights: '00N8c00000fxzpJ',
        status: '0N8c00000fy7Qr'
      },
      personal: {
        personal: '00NAq000006e55Z',
        status: '0N8c00000fy7Qr'
      },
      business: {
        business: '00NAq000006e2vz',
        business_name: 'company',
        status: '0N8c00000fy7Qr'
      },
    },
    prod: {
      subscribe: {
        enews: '00N8c00000fy1UO',
        marketinsights: '00N8c00000fxzpJ',
        status: '0N8c00000fy7Qr'
      },
      personal: {
        personal: '00NN3000004zcfa',
        status: '0N8c00000fy7Qr'
      },
      business: {
        business: '00NN3000004zcfZ',
        business_name: 'company',
        status: '0N8c00000fy7Qr'
      },
    },

  },
}

export default mapConfig
